<!--
 * @version: V1.0.0
 * @Date: 2022-12-05 15:18:22
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-07 16:00:22
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\components\DictTag\index.vue
 * @Descripttion:
-->
<template>
  <div style="display: inline">
    <template v-for="(item, index) in options">
      <template v-if="values == item.dictValue">
        <el-tag v-if="isTag" :key="item.dictValue" :type="item.listClass">{{
          item.dictLabel
        }}</el-tag>

        <span v-else :key="item.dictValue + 1" :index="index" :class="item.cssClass">{{
          item.dictLabel
        }}</span>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'DictTag',
  props: {
    options: {
      type: Array,
      default: null
    },
    isTag: {
      type: Boolean,
      default() {
        return false
      }
    },
    value: [Number, String, Array]
  },
  computed: {
    values() {
      if (this.value !== null && typeof this.value !== 'undefined') {
        return this.value
      }
    }
  }
}
</script>
<style scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
</style>
